
import React, { useEffect } from 'react';
import { universalStorage } from '@/services/storage/universalStorage';
import { storageModeManager } from '@/services/storage/storageModeManager';

interface SimpleStorageInitProps {
  onComplete: () => void;
  children: React.ReactNode;
}

export const SimpleStorageInit = ({ onComplete, children }: SimpleStorageInitProps) => {
  useEffect(() => {
    const initializeStorage = async () => {
      try {
        console.log('🚀 Initializing localStorage-only storage...');
        
        // Initialize storage mode manager
        await storageModeManager.initializeStorageMode();
        
        // Test storage functionality
        await universalStorage.setItem('nalc_init_test', { 
          initialized: true, 
          timestamp: new Date().toISOString() 
        });
        
        const testData = await universalStorage.getItem('nalc_init_test');
        if (testData) {
          console.log('✅ Storage initialized successfully');
          await universalStorage.removeItem('nalc_init_test');
          onComplete();
        } else {
          throw new Error('Storage test failed');
        }
      } catch (error) {
        console.error('❌ Storage initialization failed:', error);
        // Continue anyway - storage issues shouldn't block the app
        onComplete();
      }
    };

    initializeStorage();
  }, [onComplete]);

  return <>{children}</>; // Render children instead of null
};
